"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'platList',
  props: {
    listQuery: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      platList: []
    };
  },
  created: function created() {
    this.getPlatList();
  },
  methods: {
    getPlatList: function getPlatList() {
      var _this = this;
      this.$get('commonapi/configer/get_platform_list').then(function (res) {
        _this.platList = res;
      });
    }
  }
};